export { Skeleton } from './Skeleton';
export type { SkeletonProps } from './Skeleton';
export { default } from './Skeleton';

